import { useContext } from 'react';

import { useAppSelector } from 'src/app/store/hooks';
import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import { usePayerTripRequiredField } from '../usePayerTripRequiredField';
import { DynamicFieldNameRootContext } from './DynamicFieldNameRootContext';

export function ExternalTripId() {
  const fieldNameRoot = useContext(DynamicFieldNameRootContext);
  const selectedPayer = useAppSelector((state) => state.addATrip.selectedPayer);

  const isExternalTripIdRequired = usePayerTripRequiredField(
    'external_trip_id',
    selectedPayer
  );

  return (
    <>
      {selectedPayer?.payer_type === 'broker' && (
        <>
          <div className="col-span-12 flex flex-col">
            <FormFieldController
              name={`${fieldNameRoot}.external_trip_id`}
              rules={{
                required: isExternalTripIdRequired
                  ? 'External Trip ID is required'
                  : undefined,
              }}
            >
              {({ field, fieldState }) => {
                return (
                  <FormField
                    type="text"
                    label="External Trip ID"
                    error={fieldState.error?.message?.toString()}
                    inputProps={{
                      id: `${fieldNameRoot}.external_trip_id`,
                      ...field,
                      placeholder: 'Trip ID',
                    }}
                  />
                );
              }}
            </FormFieldController>
          </div>
        </>
      )}
    </>
  );
}
